import React from 'react';
import styled from '@emotion/styled';
import { ThemeProps } from '../../../types';
import ReCAPTCHA from 'react-google-recaptcha';
import { getReCAPTCHAKey } from '../../../utils';

export interface ReCAPTCHAProps {
  /**
   * The css class for the input. Handled internally by emotion
   */
  className?: string;
  /**
   * The error message to display
   */
  errorMessage?: string;
  /**
   * Change event handler
   */
  onChange: (token: string | null) => void;
}

const ReCAPTCHAElement = ({
  className,
  errorMessage,
  onChange,
}: ReCAPTCHAProps) => {
  //below function relies on document.location to get what site we're on, 
  //worried this'll cause an initial rendering error but similar functions that Alvin put in seem to be fine
  //if errors pop up around reCAPTCHA check this first
  const reCAPTCHAKey = getReCAPTCHAKey();
  return (
    <div className={className}>
      <ReCAPTCHA
        sitekey={reCAPTCHAKey ? reCAPTCHAKey : ""}
        onChange={onChange}
      />
      {errorMessage && <span>{errorMessage}</span>}
    </div>
  );
};

const StyledReCAPTCHAElement = styled((props: any) => <ReCAPTCHAElement {...props} />)`
  ${({ theme }: { theme: ThemeProps }) => ({
    alignSelf: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginBottom: 12,
    span: {
      color: theme.colors.error,
      fontSize: 14,
      fontStyle: 'italic',
      marginLeft: 25,
      marginTop: 5,
    },
  })}
`;

export default StyledReCAPTCHAElement;
